import { useAuth0 } from "@auth0/auth0-react";
import PreSchoolService from 'Lib/API/PreSchool/index';
import EditSvgComponent from 'assets/icons/svg/Edit/index';
import FormGeneratorComponent from 'components/FormGenerator/FormGenerator';
import { useDisableEnterKey } from "hook";
import React, { useEffect, useRef, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { formatDateInFormData, sanitizeItems } from 'utils/formDataHelper';
import { Files, FormContant, FormEditButton, FormSection, FormWrapper } from './Theme';

export const ParentFormViewer = ({ participantId, formData, handleDownload, onUpdateFormParticipant }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [fieldsData, setFieldsData] = useState({ data: [], values: [] });
  const [enableEdit, setEnableEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const originalValues = useRef([]);

  useEffect(() => {
    const taskData = formData?.parentInfoForm?.task_data || [];
    const allOptionKeys = new Set(
      taskData.flatMap((field) => (field.options || []).map((opt) => opt.key))
    );
    const filterAnswerFormData = formData?.parentInfo?.map((item) => {
      const checkBoxesOption = item?.name?.includes("checkboxes") || item?.name?.includes("radiobuttons");
      if (checkBoxesOption) {
        const checkboxesValues = item?.value?.map((value) => {
          if (allOptionKeys.has(value)) return value;
          const lastIndexOfUnderLine = value?.lastIndexOf("_");
          return value.substring(0, lastIndexOfUnderLine);
        });
        return {
          ...item,
          value: checkboxesValues,
        };
      }
      return {
        ...item,
        value: item?.value || "",
      };
    });
    originalValues.current = filterAnswerFormData || [];
    setFieldsData((prev) => ({
      ...prev,
      data: formatDateInFormData(taskData) || [],
      values: JSON.parse(JSON.stringify(filterAnswerFormData || [])),
    }));
  }, []);

  const handleCancel = () => {
    setFieldsData(prev => ({
      ...prev,
      values: JSON.parse(JSON.stringify(originalValues.current)),
    }));
    setResetKey(k => k + 1);
    setEnableEdit(false);
  };

  const onUpdateFormHandler = async (data) => {
    const filterAnswerFormData = data?.map((item) => {
      const checkBoxesOption = item?.name?.includes("checkboxes") || item?.name?.includes("radiobuttons");
      if (checkBoxesOption) {
        return { ...item, value: item?.value?.map((v) => `${v}_0`) };
      }
      return { ...item };
    });
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    PreSchoolService.updateParticipantParentInfo(token, { parentInfo: filterAnswerFormData }, participantId)
      .then(() => {
        toastr.success('Success', 'Participant updated successfully!');
        onUpdateFormParticipant();
      })
      .catch((error) => {
        toastr.error(error?.data?.message || 'Something went wrong!');
      })
      .finally(() => setIsLoading(false));
  }
  useDisableEnterKey(true);

  return (
    <FormWrapper className="view-form-wrapper">
      <FormSection style={{ background: "#fff", marginTop: "15px" }}>
        {!enableEdit && (
          <FormEditButton onClick={() => setEnableEdit(true)}>
            <EditSvgComponent />
          </FormEditButton>
        )}
        <FormContant>
          <div>
            {((fieldsData?.values?.length || enableEdit) || formData?.data?.length) && (
              <FormGeneratorComponent
                key={resetKey}
                answerData={fieldsData?.values || []}
                formData={sanitizeItems(fieldsData?.data) || []}
                enableEdit={enableEdit}
                setEnableEdit={setEnableEdit}
                onUpdateForm={onUpdateFormHandler}
                isLoading={isLoading}
                onCancel={handleCancel}
              />
            )}
            <hr />
            <div className="files__container">
              <div className="files__title">
                {`Files(${formData?.files?.length})`}
              </div>
              <Files>
                {formData?.files?.map((file, index) => (
                  <li key={index} onClick={() => { handleDownload(file) }}>file {index + 1}</li>
                ))}
              </Files>
            </div>
          </div>
        </FormContant>
      </FormSection>
    </FormWrapper>
  );
};
